import { render, staticRenderFns } from "./ProductPricelist.vue?vue&type=template&id=29477bde&"
import script from "./ProductPricelist.vue?vue&type=script&lang=js&"
export * from "./ProductPricelist.vue?vue&type=script&lang=js&"
import style0 from "./ProductPricelist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports